/* custom-stamped.js
   Behaviour for the Stamped review flow. Loaded only on /a/review/* pages (see layout/theme.liquid).
   Flow: /a/review/write  ->  review saved  ->  NPS modal opens (CSS)  ->  NPS sent  ->  /a/review/thank-you
   Findings from the QA runs:
   - After the review is saved Stamped does not reload or redirect; it sets style="display: block;" on .stamped-thank-you.
   - The NPS modal does not redirect on its own: when the NPS is sent Stamped hides .nps-submission-widget
     and closes the modal, so the redirect to the thank-you page is done here. */
(function () {
  'use strict';

  var STORE_URL = 'https://shapermint.com';
  var THANK_YOU_PATH = '/a/review/thank-you';
  var REDIRECT_DELAY_MS = 2500;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function setNativeValue(el, value) {
    if (!el) { return; }
    var proto = el.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(el, value);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function isDisplayed(el) {
    return !!el && window.getComputedStyle(el).display !== 'none';
  }

  /* ---------- /a/review/write ---------- */
  /* Stamped injects the review widget and the NPS modal after the page loads, so wait for them. */
  function waitForWriteElements(cb) {
    var tries = 0;
    var timer = window.setInterval(function () {
      var thankYou = document.querySelector('.stamped-thank-you');
      var modal = document.querySelector('.nps-submission-modal');
      tries += 1;
      if (thankYou && modal && modal.querySelector('.nps-submission-widget')) {
        window.clearInterval(timer);
        cb(thankYou, modal);
      } else if (tries > 100) {
        window.clearInterval(timer);
      }
    }, 300);
  }

  function initWritePage() {
    waitForWriteElements(setUpWritePage);
  }

  function setUpWritePage(thankYou, modal) {
    var reviewShown = false;
    var redirected = false;

    function copyContactToNps() {
      var name = document.querySelector('.new-review-form input[name="author"]');
      var email = document.querySelector('.new-review-form input[name="email"]');
      setNativeValue(modal.querySelector('.nps-name-wrapper input'), name ? name.value : '');
      setNativeValue(modal.querySelector('.nps-email-wrapper input'), email ? email.value : '');
    }

    function watchNpsCompletion() {
      var widget = modal.querySelector('.nps-submission-widget');
      if (!widget) { return; }
      var wasVisible = isDisplayed(widget);
      new MutationObserver(function () {
        if (redirected) { return; }
        var visible = isDisplayed(widget);
        if (wasVisible && !visible) {
          redirected = true;
          window.setTimeout(function () { window.location.href = THANK_YOU_PATH; }, REDIRECT_DELAY_MS);
        }
        wasVisible = visible;
      }).observe(widget, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    function onReviewSaved() {
      if (reviewShown) { return; }
      reviewShown = true;
      copyContactToNps();
      watchNpsCompletion();
      /* Stamped shows the name/email fields only after a score is picked; copy again at that moment. */
      modal.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.nps-rating')) { window.setTimeout(copyContactToNps, 50); }
      });
    }

    if (isDisplayed(thankYou) && /block/.test(thankYou.getAttribute('style') || '')) { onReviewSaved(); }
    new MutationObserver(function () {
      if (/display:\s*block/.test(thankYou.getAttribute('style') || '')) { onReviewSaved(); }
    }).observe(thankYou, { attributes: true, attributeFilter: ['style'] });
  }

  /* ---------- /a/review/thank-you ---------- */
  function initThankYouPage() {
    var wrap = document.querySelector('.stamped-proxy-thankyou');
    if (!wrap || wrap.querySelector('.ty-actions')) { return; }

    var actions = document.createElement('div');
    actions.className = 'ty-actions';

    /* "Review another item" is only added when Stamped renders its own list of other products. */
    var otherProducts = wrap.querySelector('.stamped-product-form');
    if (otherProducts) {
      var more = document.createElement('a');
      more.className = 'ty-btn ty-btn--primary';
      more.href = '#';
      more.textContent = 'Review another item';
      more.addEventListener('click', function (e) {
        e.preventDefault();
        otherProducts.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      actions.appendChild(more);
    }

    var store = document.createElement('a');
    store.className = 'ty-btn ty-btn--secondary';
    store.href = STORE_URL;
    store.textContent = 'Visit our store';
    actions.appendChild(store);

    wrap.appendChild(actions);
  }

  ready(function () {
    var path = window.location.pathname;
    if (path.indexOf('/a/review/write') === 0) { initWritePage(); }
    if (path.indexOf('/a/review/thank-you') === 0) { initThankYouPage(); }
  });
})();

/* Standalone NPS page: /pages/nps?score=N (linked from the order confirmation email).
   Stamped's NPS modal is shown by theme.liquid on this page only; here the score from the link is picked
   and the visitor is sent to the thank-you page once the NPS is submitted. */
(function () {
  'use strict';
  if (window.location.pathname.indexOf('/pages/nps') !== 0) { return; }

  var THANK_YOU_PATH = '/a/review/thank-you';
  var REDIRECT_DELAY_MS = 2500;
  var score = new URLSearchParams(window.location.search).get('score');
  var tries = 0;

  function isDisplayed(el) {
    return !!el && window.getComputedStyle(el).display !== 'none';
  }

  function watchCompletion(widget) {
    var wasVisible = isDisplayed(widget);
    var redirected = false;
    new MutationObserver(function () {
      var visible = isDisplayed(widget);
      if (!redirected && wasVisible && !visible) {
        redirected = true;
        window.setTimeout(function () { window.location.href = THANK_YOU_PATH; }, REDIRECT_DELAY_MS);
      }
      wasVisible = visible;
    }).observe(widget, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  var timer = window.setInterval(function () {
    var modal = document.querySelector('.nps-submission-modal');
    var widget = modal && modal.querySelector('.nps-submission-widget');
    var ratings = modal ? modal.querySelectorAll('.nps-rating .rating') : [];
    tries += 1;
    if (widget && ratings.length) {
      window.clearInterval(timer);
      watchCompletion(widget);
      Array.prototype.forEach.call(ratings, function (r) {
        if (score && r.textContent.trim() === score) { r.click(); }
      });
    } else if (tries > 100) {
      window.clearInterval(timer);
    }
  }, 300);
})();
